export default {
    name: 'Loader',
    data () {
        return {
        }
    },
    props: {
        type: {
            type: String,
            default: 'medium'
        }
    },
    methods: {
    }
}


// WEBPACK FOOTER //
// ./src/components/loader/loader.js